// Recovered compiled webpack factory 47850. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { E: () => l });
  var a = r(95155),
    n = r(12115);
  function l(e) {
    let { children: t, className: r, style: l } = e,
      s = (0, n.useRef)(null);
    return (
      (0, n.useLayoutEffect)(() => {
        let e = s.current;
        return () => {
          null == e ||
            e.querySelectorAll("canvas").forEach((e) => {
              var t;
              let r = e.getContext("webgl2");
              null == r || null == (t = r.getExtension("WEBGL_lose_context")) || t.loseContext();
            });
        };
      }, []),
      (0, a.jsx)("div", { ref: s, className: r, style: l, children: t })
    );
  }
}
